import ls from 'localstorage-slim';
import { Feature, FeatureToggles } from './types';

const featureToggles = ls.get('featureToggles', {
  decrypt: true,
}) as FeatureToggles | null;

const config: FeatureToggles = {
  [Feature.CreditCheckSnacker]: {
    enabled: featureToggles?.[Feature.CreditCheckSnacker]?.enabled ?? false,
    type: Feature.CreditCheckSnacker,
    dependents: [Feature.Feedback],
  },
  [Feature.Feedback]: {
    enabled: featureToggles?.[Feature.Feedback]?.enabled ?? false,
    type: Feature.Feedback,
  },
};

export default config;
